import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=66727fad&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66727fad')) {
      api.createRecord('66727fad', component.options)
    } else {
      api.reload('66727fad', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=66727fad&", function () {
      api.rerender('66727fad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28qZvRlhJ7vuJ/JS/comp/ErrorMessage.vue"
export default component.exports